import { openDB } from 'idb';

const DB_NAME = 'catalyst-games-environment';
// bump the version if there is new additional store
const DB_VERSION = 11;

export const stores = [
  'game-document',
  'game-state',
  'player-state',
  'team-state',
  'trade',
  'feedback-document',
  'upload-queue',
  'scoring-queue'
] as const;
export type StoreName = (typeof stores)[number];

export const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db, oldVersion, newVersion, transaction) {
    // handle renaming uploads to upload-queue
    if (oldVersion < 11) {
      if (db.objectStoreNames.contains('uploads')) {
        // create the new store
        db.createObjectStore('upload-queue', {
          keyPath: 'playerCode'
        });

        // delete old store
        db.deleteObjectStore('uploads');
      }

      // delete old store
      if (db.objectStoreNames.contains('clock')) db.deleteObjectStore('clock');
    }

    for (const name of stores) {
      if (!db.objectStoreNames.contains(name)) {
        console.info(`Creating object store: ${name}`);
        db.createObjectStore(name, {
          keyPath:
            name === 'feedback-document'
              ? 'feedbackCode'
              : name === 'upload-queue' || name === 'scoring-queue'
                ? 'playerCode'
                : 'gameCode'
        });
      }
    }
  }
});

export const putToStore = async <T>(
  storeName: StoreName,
  value: T
): Promise<void> => {
  const db = await dbPromise;
  let stored = value;

  if (storeName !== 'game-document') {
    // sanitized before put it to idb store
    stored = JSON.parse(JSON.stringify(value));
  }

  await db.put(storeName, stored);
};

export const getFromStore = async <T>(
  storeName: StoreName,
  code: string
): Promise<T | undefined> => {
  const db = await dbPromise;
  return db.get(storeName, code);
};

export const getAllFromStore = async <T>(storeName: StoreName): Promise<T> => {
  const db = await dbPromise;
  return db.getAllKeys(storeName) as T;
};

export const deleteFromStore = async <T>(
  storeName: StoreName,
  code: string
): Promise<void> => {
  const db = await dbPromise;
  await db.delete(storeName, code);
};
